import { createUseStyles } from 'react-jss';

import { Transition } from '../../../styles/enums';
import { canHover } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 56,
      height: 56,

      border: `2px solid ${colors.primary}`,
      borderRadius: '50%',

      backgroundColor: colors.background,

      transition: `background-color ${Transition.Default} ease-in-out`,

      [canHover()]: {
        '&:hover:not([disabled])': {
          backgroundColor: colors.primary,

          '& > $icon > svg > path': {
            fill: colors.background,
          },
        },
      },
      [canHover(false)]: {
        '&:active:not([disabled])': {
          backgroundColor: colors.primary,

          '& > $icon > svg > path': {
            fill: colors.background,
          },
        },
      },

      '&[disabled]': {
        opacity: '0.5',
        cursor: 'default',
      },
    },
    icon: {
      display: 'inline-block',
      width: 24,
      height: 24,

      '& > svg': {
        '& > path': {
          fill: colors.primary,
          transition: `fill ${Transition.Default} ease-in-out`,
        },
      },
    },
  }),
  {
    name: 'circle-button',
  },
);

export default useStyles;
